export default __webpack_public_path__ + "12ef8a6.png";